module.exports = __webpack_public_path__ + "img/客户icon_2.083e48dc.png";